/** Isolated candidate only. No mounted routes, network, cookies or credentials. */
export const HANDOFF_ENABLED = false;
export const RENDER_ORIGIN = 'https://www.valoria.net';
export const PRIVATE_ORIGIN = 'https://valoria-worlds.saintvalor.chatgpt.site';
export const HANDOFF_URL = PRIVATE_ORIGIN + '/creator-handoff';
export const PROTOCOL = 'valoria.owner-handoff/v1';
export const LIMITS = Object.freeze({ noticeBytes: 8192, noticeLifetimeMs: 60000, timeoutMs: 120000 });
export const BINDING_FIELDS = ['ownerAccountId', 'renderJobId', 'requestId', 'noticeId', 'attemptNonce', 'pageNonce', 'expiresAt'];
export const RECEIPT_FIELDS = ['accepted', 'duplicate', 'status', 'jobId', ...BINDING_FIELDS, 'eventId'];
const ID = /^[A-Za-z0-9][A-Za-z0-9_.:@-]{0,127}$/;
export const isId = value => typeof value === 'string' && ID.test(value);
export const isNonce = value => typeof value === 'string' && /^[a-f0-9]{64}$/.test(value);
export const isObject = value => value !== null && typeof value === 'object' && !Array.isArray(value);
export const exact = (value, fields) => isObject(value) && Object.keys(value).length === fields.length && fields.every(key => Object.hasOwn(value, key));
export function fail(code) { throw new Error(code); }
export function nonce() {
  return [...globalThis.crypto.getRandomValues(new Uint8Array(32))].map(x => x.toString(16).padStart(2, '0')).join('');
}
export function clock(value) {
  if (!Number.isSafeInteger(value) || value < 0) fail('INVALID_CLOCK');
  return value;
}
export function binding(value) {
  return exact(value, BINDING_FIELDS) && ['ownerAccountId', 'renderJobId', 'requestId', 'noticeId'].every(key => isId(value[key]))
    && isNonce(value.attemptNonce) && isNonce(value.pageNonce) && Number.isSafeInteger(value.expiresAt) && value.expiresAt > 0;
}
export function receipt(value, expected) {
  return exact(value, RECEIPT_FIELDS) && value.accepted === true && typeof value.duplicate === 'boolean' && value.status === 'outbox-persisted'
    && binding(Object.fromEntries(BINDING_FIELDS.map(key => [key, value[key]])))
    && BINDING_FIELDS.every(key => value[key] === expected[key]) && typeof value.jobId === 'string' && /^livejob_[a-f0-9]{64}$/.test(value.jobId)
    && value.eventId === 'liveevt_' + value.jobId.slice(8);
}
export function notice(value) {
  return typeof value === 'string' && value.length > 0 && value.length <= LIMITS.noticeBytes
    && new TextEncoder().encode(value).byteLength <= LIMITS.noticeBytes;
}
export function frame(type, fields = {}) { return { protocol: PROTOCOL, type, ...fields }; }
export function isFrame(value, type, fields) { return exact(value, ['protocol', 'type', ...fields]) && value.protocol === PROTOCOL && value.type === type; }
export function sameSession(a, b) {
  return isObject(a) && isObject(b) && isId(a.id) && isId(a.epoch) && a.id === b.id && a.epoch === b.epoch;
}
